import Button from '@mui/material/Button';
import { Link as RouterLink, useRouteError } from 'react-router-dom';
import { EmptyState } from '@/shared/components/EmptyState';

const isChunkError = (err: unknown) =>
  err instanceof Error && /dynamically imported module|Loading chunk/i.test(err.message);

export function RouteError({ notFound = false }: { notFound?: boolean }) {
  const error = useRouteError();

  if (notFound) {
    return (
      <EmptyState
        title="Page not found"
        hint="The link may be out of date."
        action={<Button component={RouterLink} to="/library" variant="contained">Go to the research library</Button>}
      />
    );
  }

  if (isChunkError(error)) {
    return (
      <EmptyState
        title="A new version is available"
        hint="Reload to pick up the latest build."
        action={<Button variant="contained" onClick={() => { window.location.reload(); }}>Reload</Button>}
      />
    );
  }

  return (
    <EmptyState
      title="This screen hit a problem"
      hint="Other screens still work. Reload this one or go back to the library."
      action={<Button variant="contained" onClick={() => { window.location.reload(); }}>Reload</Button>}
    />
  );
}
